import { EERIE } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCallback } from 'react';
import UIAlert from 'UIComponents/alert/UIAlert';
import UIIcon from 'UIComponents/icon/UIIcon';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { useLocalStorage } from '../../local-storage/hooks/useLocalStorage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const IDENTIFY_CONTACT_TOOLTIP_HIDDEN = 'IDENTIFY_CONTACT_TOOLTIP_HIDDEN';
const IdentifyContactWarning = ({
  vid
}) => {
  const [item, setItem] = useLocalStorage({
    key: IDENTIFY_CONTACT_TOOLTIP_HIDDEN,
    initialValue: JSON.stringify({
      [vid]: false
    })
  });
  const getIsClosed = useCallback(() => {
    try {
      return JSON.parse(item)[vid];
    } catch (e) {
      return false;
    }
  }, [item, vid]);
  const setHidden = useCallback(() => setItem(JSON.stringify(Object.assign({}, JSON.parse(item), {
    [vid]: true
  }))), [item, setItem, vid]);
  return getIsClosed() ? null : /*#__PURE__*/_jsxs(UIAlert, {
    type: "tip",
    use: "inline",
    closeable: true,
    onClose: setHidden,
    className: "m-top-2 m-bottom-4 p-all-2",
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-inbox-ui.crm-integration.IdentifyContactTip.alert",
      useGap: true
      // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
      ,
      style: {
        fontWeight: 600
      }
    }), /*#__PURE__*/_jsx(UITooltip, {
      placement: "bottom left",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-ui.crm-integration.IdentifyContactTip.tooltip"
      }),
      children: /*#__PURE__*/_jsx(UIIcon, {
        name: "info",
        size: 16,
        color: EERIE
      })
    })]
  });
};
IdentifyContactWarning.displayName = 'IdentifyContactWarning';
export default IdentifyContactWarning;